<template>
    <div class="uploadAdmissionPhotos">
        <div class="uploadAdmissionPhotos-box">
            <div class="cont">
                <Title text="入学照上传" />
                <div class="info" v-if="info.enter_school_img ? true : false">
                    <div class="item">
                        <span class="title">审核状态</span>
                        <span class="value">
                            <el-tag :type="info.enter_school_img_check | isEnterSchoolImgCheckStyle">
                                {{ info.enter_school_img_check | isEnterSchoolImgCheckFilter }}
                            </el-tag>
                        </span>
                    </div>
                    <div class="item" v-if="info.check_remark ? true : false">
                        <span class="title">审核备注</span>
                        <span class="value">{{info.check_remark}}</span>
                    </div>
                    <div class="item">
                        <span class="title">入学照</span>
                        <span class="value">
                            <!-- <img :src="enterSchoolImg" alt="" style="width: 500px;"> -->
                            <el-image
                                :src="info.enter_school_img"
                                fit="contain"
                                :preview-src-list="[info.enter_school_img]"
                                style="height: 200px;width: 200px;"
                            ></el-image>
                        </span>
                    </div>
                </div>
                <div class="upload" v-if="enterSchoolImgCheck == 0 || info.enter_school_img_check == 0 || info.enter_school_img_check == 3">
                    <el-upload
                        class="upload-demo"
                        action=""
                        :http-request="upLoadImg"
                        :show-file-list="false">
                        <el-button type="primary">上传入学照</el-button>
                    </el-upload>
                    <div class="tips">请上传蓝底的登记照</div>
                </div>
            </div>
        </div>
        <el-button class="exit-btn" type="primary" @click="exit">退出登录</el-button>
    </div>
</template>

<script>
import { mapState } from "vuex";
import {putObject} from '@/utils/upload';
import {isAssetTypeAnImage} from '@/utils/func';
import {adultStudentUserEnterImg, adultStudentUserGetEnterImg} from '@/api/login';
export default {
    name: 'uploadAdmissionPhotos',
    filters: {
        // 审核状态
        isEnterSchoolImgCheckFilter(v){
            let obj = {
                0: '待上传',
                1: '待审核',
                2: '审核通过',
                3: '未通过',
            };
            return obj[v];
        },
        // 审核状态 样式
        isEnterSchoolImgCheckStyle(v){
            let obj = {
                0: '',
                1: '',
                2: 'success',
                3: 'danger',
            };
            return obj[v];
        },
    },
    data(){
        return {
            info: {}
        };
    },
    computed: {
        ...mapState("permission", {
            // enterSchoolImg: state => state.enterSchoolImg,  //入学照
            enterSchoolImgCheck: state => state.enterSchoolImgCheck,  //入学照审核状态
            // userInfo: state => JSON.parse(state.userInfo),  //入学照
        }),
    },
    created(){
        // if(this.enterSchoolImgCheck != 0){
        //     this.getData();
        // }
      this.getData();
    },
    methods: {
        // 退出
        async exit() {
            // loginOut(null).then(() => {
            // this.$store.dispatch('permission/setIsGenerateRoutes', '');
            await this.$store.dispatch('permission/logOut');
            // Cookies.remove('token');
            this.$message.success('退出成功');
            this.$router.replace("/Login");

            // });
        },
        getData(){
            adultStudentUserGetEnterImg().then(res => {
                if(res.code == 200){
                    this.info = res.result;
                    if(res.result.enter_school_img_check == 2){
                        this.$store.dispatch('permission/enterSchoolImgCheckActions', res.result.enter_school_img_check);
                        this.$router.push({
                            name: "home",
                        });
                    }
                }
            });
        },
        // 上传照片
        upLoadImg(file){
            let type = file.file.name.split('.')[file.file.name.split('.').length - 1];

            let isImg = isAssetTypeAnImage(type);

            if (!isImg) {
                this.$message.error('文件类型不正确，请选择图片格式的文件');
                return;
            }

            putObject(file, async url => {
                if (url) {
                    // const str = url.split('.zip')[0];
                    const params = {
                        enter_school_img: url
                    };
                    let res = await adultStudentUserEnterImg(params);
                    if (res.code == 200) {
                        this.$message.success('上传成功');
                        this.getData();
                        // this.seeImageUrl = url;
                        // this.$store.dispatch('permission/enterSchoolImgCheckActions', 1);
                        // this.$store.dispatch('permission/enterSchoolImgActions', url);
                    }
                }
            }, null, 'student', type );
        },
    },
}
</script>

<style lang="scss" scoped>
    .uploadAdmissionPhotos{
        .exit-btn{
            position: fixed;
            top: 10px;
            right: 10px;
        }
        .uploadAdmissionPhotos-box{
            width: 1000px;
            margin: 20px auto;
            display: flex;
            justify-content: center;
            .cont{
                .upload{
                    .tips{
                        color: #fa9050;
                        height: 30px;
                        margin-top: 5px;
                    }
                }
                .info{
                    .item{
                        margin: 10px 0;
                        display: flex;
                        .title{
                            font-weight: 600;
                            width: 80px;
                            text-align: right;
                        }
                        .value{
                            width: calc(100% - 90px);
                            padding-left: 10px;
                        }
                    }
                }
            }
        }
    }
</style>
